const blockchainConfig = {
    mainnet: {

    },
    testnet: {
        chainId: '0x5',
        chainName: 'Goerli Testnet',
        rpcUrl: "https://goerli.infura.io/v3/",
        explorerUrl: "https://goerli.etherscan.io/",
        contractAddresses: {
            "stablecoin": "0x520b71cd62468078c331AABaF05a185984548eb8",
            "nftFactory": "0x617A2F6Fc3f7d825610Dfe93d4AA618727EDf0a0",
            "storeFactory": "0x34Af65b5A6A379dc54139899bC17c0cf998e0404",
            "proposalFactory": "0x94dA9494f76872BF07d849E954a9f3e313Bd821F"
        }
    }
}

export default blockchainConfig[process.env.VUE_APP_BLOCKCHAIN_NETWORK]